<template>
  <!-- <div class="undeveloped">
    <img src="/static/picture/undeveloped.png" alt="">
  </div> -->
  <div class="pages">
    <div class="name">霆竣内部系统</div>
    <div class="navigation">
      <div class="nav" v-for="(item, index) in nav" :key="index" @click="jumpCrm(item.sysName)">
        <div class="icon">
          <img :src="item.img" alt="" />
        </div>
        <div class="navName">
          <span>{{ item.navName }}</span>
          <el-tooltip class="item" effect="dark" :content="item.name" placement="bottom">
            <p>{{ item.name }}</p>
          </el-tooltip>
        </div>
      </div>
    </div>
    <div class="name" style="margin-top: 32px">常用功能</div>
    <div class="navigation">
      <div class="nav" v-for="(it, key) in nav2" :key="key" @click="jumpCrm2(it.sysName)">
        <div class="icon">
          <img :src="it.img" alt="" />
        </div>
        <div class="navName">
          <span>{{ it.navName }}</span>
          <el-tooltip class="item" effect="dark" :content="it.name" placement="bottom">
            <p>{{ it.name }}</p>
          </el-tooltip>
        </div>
      </div>
    </div>
    <archives-apply-for :isShow="ArchivesDialogShow" @cancel="ArchivesDialogShow = false" v-if="ArchivesDialogShow" />
    <post-grade-dialog :show="PostGradeDialogShow" @close="PostGradeDialogShow = false" v-if="PostGradeDialogShow" />
    <job-mobility-dialog :show="JobMobilityDialogShow" @close="JobMobilityDialogShow = false" v-if="JobMobilityDialogShow" />
    <job-quit :isShow.sync="jobQuitDialogShow" />
  </div>
</template>
<script>
import ArchivesApplyFor from '../archivesApplyFor';
import PostGradeDialog from '../postGrade';
import JobMobilityDialog from '../jobMobility';
import JobQuit from '../jobQuit';
export default {
  name: 'quickNavList',
  components: { ArchivesApplyFor, PostGradeDialog, JobMobilityDialog, JobQuit },
  data() {
    return {
      nav: [
        {
          navName: '霆竣工程咨询官网',
          name: '霆竣工程咨询官网',
          sysName: 'gw',
          img: '/static/picture/skypegmwcn.png',
        },
        {
          navName: 'CRM客户管理系统',
          name: 'Customer Relationship Management客户管理系统',
          sysName: '/crm/CrmSysNav',
          img: '/static/picture/CRM.png',
        },
        {
          navName: 'OMS运营管理系统',
          name: 'Operations Management System运营管理',
          sysName: '/oms/OmsSysNav',
          img: '/static/picture/OMS.png',
        },
        {
          navName: 'RM风控管理系统',
          name: 'isk Management企业风险评估',
          sysName: '/rm/RmSysNav',
          img: '/static/picture/RM.png',
        },
        {
          navName: 'FMS财务管理系统',
          name: 'Financial Management System财务管理',
          sysName: '/fms/FmsSysNav',
          img: '/static/picture/FMS.png',
        },
        {
          navName: 'eHR人力资源管理系统',
          name: 'Electronic Health Record人力资源管理系统',
          sysName: '/ehr/EhrSysNav',
          img: '/static/picture/eHR.png',
        },
        {
          navName: 'BI数据可视化统计',
          name: 'Business Intelligence数据可视化统计看板',
          sysName: '/BI/financeNav',
          img: '/static/picture/BI.png',
        },
      ],
      nav2: [
        {
          navName: '企查查',
          name: '企业工商信息、股东、受益人查询',
          sysName: 'https://www.qcc.com/',
          img: '/static/picture/qcc.png',
        },
        {
          navName: '天眼查',
          name: '企业工商信息、股东、受益人查询',
          sysName: 'https://www.tianyancha.com/',
          img: '/static/picture/tyc.png',
        },
        {
          navName: '四库一平台',
          name: '全国建筑市场监管公共服务平台',
          sysName: 'https://jzsc.mohurd.gov.cn/home',
          img: '/static/picture/skypt.png',
        },
        {
          navName: '建设通',
          name: '建筑行业数字化综合服务平台',
          sysName: 'https://www.cbi360.net/hhb/',
          img: '/static/picture/jst.png',
        },
        {
          navName: '信用中国',
          name: '提供对社会公开的信用信息官方平台',
          sysName: 'https://www.creditchina.gov.cn/',
          img: '/static/picture/xyzg.png',
        },
        {
          navName: '建设库',
          name: '建筑产业大数据综合服务平台',
          sysName: 'https://www.jiansheku.com/',
          img: '/static/picture/jsk.png',
        },
        {
          navName: '档案调阅',
          name: '企业投标、履约资料管理',
          sysName: 'archives',
          img: '/static/picture/archives.png',
        },
        {
          navName: '插件工具',
          name: '人民币转化、时间计算',
          sysName: 'tools',
          img: '/static/picture/tools.png',
        },

        {
          navName: '岗位评级申请',
          name: '岗位等级线上评估申请',
          sysName: '',
          // sysName: 'grade',
          img: '/static/picture/grade.png',
        },
        {
          navName: '授权管理',
          name: '人员账号权限授权管理',
          sysName: '/ehr/AuthorizationList',
          img: '/static/picture/authorize.png',
        },
        {
          navName: '调岗申请',
          name: '运营岗位调整线上申请',
          sysName: '',
          // sysName: 'jobMobility',
          img: '/static/picture/jobMobility.png',
        },
        {
          navName: '离职申请',
          name: '员工解除劳动合同意向申请',
          sysName: '',
          sysName: 'jobQuit',
          img: '/static/picture/job-quit.png',
        },
      ],
      ArchivesDialogShow: false,
      PostGradeDialogShow: false,
      JobMobilityDialogShow: false,
      jobQuitDialogShow: false,
    };
  },
  methods: {
    jumpCrm(sysName) {
      if (sysName == 'gw') window.open('http://www.sztjdb.com/');
      else if (!sysName) this.$message.warning('页面不存在或无页面权限');
      else if (/^http/.test(sysName)) window.open(sysName);
      else this.$router.push(sysName);
    },
    jumpCrm2(sysName) {
      if (sysName == 'archives') this.ArchivesDialogShow = true;
      else if (sysName == 'tools') this.$emit('toggle', { name: 'PluginTools' });
      else if (sysName == 'grade') this.PostGradeDialogShow = true;
      else if (sysName == 'jobMobility') this.JobMobilityDialogShow = true;
      else if (sysName == 'jobQuit') this.jobQuitDialogShow = true;
      else if (!sysName) this.$message.warning('页面不存在或无页面权限');
      else if (/^http/.test(sysName)) window.open(sysName);
      else this.$router.push(sysName);
    },
  },
};
</script>
<style scoped lang="less">
.pages {
  background-color: #fff;
  padding: 24px;
  height: 100%;
  .name {
    font-size: 18px;
    font-weight: bold;
    color: #3a4151;
  }
  .navigation {
    display: flex;
    flex-wrap: wrap;
    cursor: pointer;
    .nav {
      width: 280px;
      height: 94px;
      background: #fff;
      box-shadow: 0px 2px 6px rgba(21, 79, 157, 0.08);
      opacity: 1;
      border-radius: 8px;
      margin-top: 20px;
      margin-right: 20px;
      display: flex;
      align-items: center;
      .icon {
        width: 46px;
        height: 46px;
        margin-left: 24px;
        margin-right: 12px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .navName {
        span {
          font-size: 16px;
          font-weight: bold;
          color: #3a4151;
        }
        p {
          width: 175px;
          font-size: 14px;
          color: #adb0c1;
          margin-top: 4px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
}
</style>
